<template>
    <div>
        <van-form @submit="onSubmit">
            <van-field v-model="username" name="用户名" label="用户名" placeholder="用户名"
                :rules="[{ required: true, message: '请填写用户名' }]" />
            <van-field v-model="password" type="password" name="密码" label="密码" placeholder="密码"
                :rules="[{ required: true, message: '请填写密码' }]" />
                <van-field v-model="password" type="password" name="密码" label="密码" placeholder="密码"
                :rules="[{ required: true, message: '请填写密码' }]" />
                <van-field v-model="password" type="password" name="密码" label="密码" placeholder="密码"
                :rules="[{ required: true, message: '请填写密码' }]" />
                <van-field v-model="password" type="password" name="密码" label="密码" placeholder="密码"
                :rules="[{ required: true, message: '请填写密码' }]" />

                <van-field v-model="password" type="password" name="密码" label="密码" placeholder="密码"
                :rules="[{ required: true, message: '请填写密码' }]" />
                <van-field v-model="password" type="password" name="密码" label="密码" placeholder="密码"
                :rules="[{ required: true, message: '请填写密码' }]" />

                <van-field v-model="password" type="password" name="密码" label="密码" placeholder="密码"
                :rules="[{ required: true, message: '请填写密码' }]" />
                <van-field v-model="password" type="password" name="密码" label="密码" placeholder="密码"
                :rules="[{ required: true, message: '请填写密码' }]" />
                <van-field v-model="password" type="password" name="密码" label="密码" placeholder="密码"
                :rules="[{ required: true, message: '请填写密码' }]" />
                <van-field v-model="password" type="password" name="密码" label="密码" placeholder="密码"
                :rules="[{ required: true, message: '请填写密码' }]" />
                <van-field v-model="password" type="password" name="密码" label="密码" placeholder="密码"
                :rules="[{ required: true, message: '请填写密码' }]" />

                <van-field v-model="password" type="password" name="密码" label="密码" placeholder="密码"
                :rules="[{ required: true, message: '请填写密码' }]" />
                <van-field v-model="password" type="password" name="密码" label="密码" placeholder="密码"
                :rules="[{ required: true, message: '请填写密码' }]" />
                <van-field v-model="password" type="password" name="密码" label="密码" placeholder="密码"
                :rules="[{ required: true, message: '请填写密码' }]" />
                <van-field v-model="password" type="password" name="密码" label="密码" placeholder="密码"
                :rules="[{ required: true, message: '请填写密码' }]" />
                <van-field v-model="password" type="password" name="密码" label="密码" placeholder="密码"
                :rules="[{ required: true, message: '请填写密码' }]" />
                <van-field v-model="password" type="password" name="密码" label="密码" placeholder="密码"
                :rules="[{ required: true, message: '请填写密码' }]" />
            <div style="margin: 16px;">
                <van-button round block type="primary" native-type="submit">
                    提交
                </van-button>
            </div>
        </van-form>
        <van-button round block type="primary" @click="SetCookie">
        cun
        </van-button>
        <van-button round block type="primary" @click="getCookie">
        去
        </van-button>
    </div>
</template>

<script>
    import VueCookie from 'vue-cookie'
    // import Vue from 'vue';
    // import {setCookie,getCookie,delCookie} from '@/assets/js/cookie'
    // Vue.prototype.$cookieStore = {setCookie,getCookie,delCookie}
    // import Cook from 'vue-cookie'
    // Vue.prototype.Cook = cookie
    export default {
        data(){
            return {
                username: '',
                password: '',
            }
        },
        // mounted(){
        //     Vue.prototype.$cookieStore = {setCookie,getCookie,delCookie}
        // },
        methods:{
            onSubmit(values) {
                console.log(values)
                // this.getCookie()
            //    this.$router.push({
            //         path:'/Textone'
            //     })
            },

            SetCookie(){
                // Vue.prototype. cookie = VueCookie
                VueCookie.set('sss','saa')
                // this.$Cook.set('userName','b')
                // this.$cookieStore.setCookie('userName','LI')
            },
            getCookie(){
                // var sssss = VueCookie.get('sss')
                // // cookie.get('a');
                // console.log(sssss)
                // alert(sssss)
                console.log(VueCookie.get('aaaa'))
            }


        },
        created(){
            VueCookie.set('aaaa','abc')
            VueCookie.set('aaaa','bcd')
        }
    }
</script>

<style scoped>

</style>